export enum SESSION_STORAGE_KEYS {
  ZAMP_ADD_TEAM = 'ZAMP_ADD_TEAM',
  ZAMP_LOGIN_TOKEN = 'ZAMP_LOGIN_TOKEN',
}

export const getFromSessionStorage = (key: string) => {
  return sessionStorage.getItem(key);
};

export const setToSessionStorage = (key: SESSION_STORAGE_KEYS, value: string) => {
  sessionStorage.setItem(key, value);
};

export const removeFromSessionStorage = (key: SESSION_STORAGE_KEYS) => {
  sessionStorage.removeItem(key);
};
